import {IColumn} from "@fluentui/react";
import strings from "../../../loc/strings";

export enum Tab {
    Active = "active",
    Outgoing = "outgoing",
    Incoming = "incoming",
    Draft = "draft"
}

export enum Status {
    Draft = 1,
    Submitted,
    InProgress,
    Postpone,
    Impossible,
    Partially,
    Responded,
    SystemClosed,
    Cancelled
}

export enum ColumnFieldName {
    IsOutgoing = "isOutgoing",
    RequestNo = "requestNo",
    CaInternalAssessmentNo = "caInternalAssessmentNo",
    Authority = "authority",
    EuSecLegBasis = "euSecLegBasis",
    PersonType = "personType",
    PersonOfInterest = "personOfInterest",
    SubmissionDate = "submissionDate",
    Status = "status",
    ExpectedCompDate = "expectedCompDate",
    RemainingDays = "remainingDays",
    Actions = "actions",
}

export const _activeColumns: IColumn[] = [
    {
        key: "column0",
        name: strings.columnNameOutgoing,
        fieldName: ColumnFieldName.IsOutgoing,
        minWidth: 35,
        maxWidth: 35
    },
    {
        key: "column1",
        name: strings.columnNameRequestNo,
        fieldName: ColumnFieldName.RequestNo,
        minWidth: 100,
        maxWidth: 120,
        isResizable: true
    },
    {
        key: "column2",
        name: strings.columnNameCA,
        fieldName: ColumnFieldName.CaInternalAssessmentNo,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column3",
        name: strings.columnNameAuthority,
        fieldName: ColumnFieldName.Authority,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column4",
        name: strings.columnNameBasis,
        fieldName: ColumnFieldName.EuSecLegBasis,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true
    },
    {
        key: "column5",
        name: strings.columnNameType,
        fieldName: ColumnFieldName.PersonType,
        minWidth: 70,
        maxWidth: 150,
        isResizable: true
    },
    {
        key: "column6",
        name: strings.columnNamePOI,
        fieldName: ColumnFieldName.PersonOfInterest,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column7",
        name: strings.columnNameSubmissionDate,
        fieldName: ColumnFieldName.SubmissionDate,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        isSorted: true,
        isSortedDescending: false
    },
    {
        key: "column8",
        name: strings.columnNameStatus,
        fieldName: ColumnFieldName.Status,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column9",
        name: strings.columnNameExpectedDate,
        fieldName: ColumnFieldName.ExpectedCompDate,
        minWidth: 180,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column10",
        name: strings.columnNameRemaining,
        fieldName: ColumnFieldName.RemainingDays,
        minWidth: 80,
        isResizable: true
    },
    {
        key: "column11",
        name: strings.columnNameActions,
        fieldName: ColumnFieldName.Actions,
        minWidth: 50,
        maxWidth: 80,
        isResizable: true,
    }
];

export const _outgoingColumns: IColumn[] = [
    {
        key: "column0",
        name: strings.columnNameRequestNo,
        fieldName: "requestNo",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column1",
        name: strings.columnNameCA,
        fieldName: "caInternalAssessmentNo",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column2",
        name: strings.columnNameRequestedAuthority,
        fieldName: "authority",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column3",
        name: strings.columnNameBasis,
        fieldName: "euSecLegBasis",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column4",
        name: strings.columnNameType,
        fieldName: "personType",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column5",
        name: strings.columnNamePOI,
        fieldName: "personOfInterest",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column6",
        name: strings.columnNameSubmissionDate,
        fieldName: "submissionDate",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        isSorted: true,
        isSortedDescending: true
    },
    {
        key: "column7",
        name: strings.columnNameStatus,
        fieldName: "status",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column8",
        name: strings.columnNameExpectedDate,
        fieldName: "expectedCompDate",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column9",
        name: strings.columnNameRemaining,
        fieldName: "remainingDays",
        minWidth: 80,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column10",
        name: strings.columnNameClosingDate,
        fieldName: "closingDate",
        minWidth: 100,
        isResizable: true,
    },
    {
        key: "column11",
        name: strings.columnNameActions,
        fieldName: "actions",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    }
];

export const _incomingColumns: IColumn[] = [
    {
        key: "column0",
        name: strings.columnNameRequestNo,
        fieldName: "requestNo",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true
    },
    {
        key: "column1",
        name: strings.columnNameCA,
        fieldName: "caInternalAssessmentNo",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column2",
        name: strings.columnNameRequestingAuthority,
        fieldName: "authority",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column3",
        name: strings.columnNameBasis,
        fieldName: "euSecLegBasis",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column4",
        name: strings.columnNameType,
        fieldName: "personType",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column5",
        name: strings.columnNamePOI,
        fieldName: "personOfInterest",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column6",
        name: strings.columnNameSubmissionDate,
        fieldName: "submissionDate",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        isSorted: true,
        isSortedDescending: true
    },
    {
        key: "column7",
        name: strings.columnNameStatus,
        fieldName: "status",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column8",
        name: strings.columnNameExpectedDate,
        fieldName: "expectedCompDate",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column9",
        name: strings.columnNameRemaining,
        fieldName: "remainingDays",
        minWidth: 80,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "column10",
        name: strings.columnNameClosingDate,
        fieldName: "closingDate",
        minWidth: 100,
        isResizable: true,
    },
    {
        key: "column11",
        name: strings.columnNameActions,
        fieldName: "actions",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    }
];

export const _draftColumns: IColumn[] = [
    {
        key: "column0",
        name: strings.columnNameRequestedAuthority,
        fieldName: "authority",
        minWidth: 300,
        maxWidth: 400,
        isResizable: true
    },
    {
        key: "column1",
        name: strings.columnNamePOI,
        fieldName: "personOfInterest",
        minWidth: 150,
        maxWidth: 250,
        isResizable: true
    },
    {
        key: "column2",
        name: strings.columnNameType,
        fieldName: "personType",
        minWidth: 150,
        maxWidth: 250,
        isResizable: true
    },
    {
        key: "column3",
        name: strings.columnNameCreationDate,
        fieldName: "creationDate",
        minWidth: 150,
        isResizable: true,
        isSorted: true,
        isSortedDescending: true
    },
    {
        key: "column4",
        name: strings.columnNameActions,
        fieldName: "actions",
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    }
];